import { createApp } from 'vue';
import Toast, { POSITION } from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import { Vue3Mq } from 'vue3-mq';
import Vue3TouchEvents from 'vue3-touch-events';
import VueMobileDetection from 'vue-mobile-detection';
import { createGtm } from '@gtm-support/vue-gtm';
import { createHead } from '@unhead/vue';
import { UnheadPlugin } from '@unhead/vue/vue2';

const app = createApp(App);
const head = createHead()

const toastOptions = {
  // You can set your default options here
  position: POSITION.BOTTOM_LEFT
};

app.use(router);
app.use(store);
app.use(Toast, toastOptions);
app.use(Vue3Mq, {
  breakpoints: {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1280,
  }
});
app.use(Vue3TouchEvents);
app.use(VueMobileDetection);
app.use(head);
app.use(UnheadPlugin);

if (process.env.NODE_ENV === 'production') {
  app.use(
    createGtm({
      id: 'GTM-K9PH4KZ', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    }),
  );
} else {
  app.use(
    createGtm({
      id: 'GTM-WZRHTSC', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    }),
  );
}

app.mount('#app');
